import { render, staticRenderFns } from "./FlagDetails.vue?vue&type=template&id=57d79193&"
import script from "./FlagDetails.vue?vue&type=script&lang=js&"
export * from "./FlagDetails.vue?vue&type=script&lang=js&"
import style0 from "./FlagDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports